export const SITE = "https://goodhomeimprovement.com";

export const BIZ = {
  name: "Good Home Improvement LLC",
  phone: "414-396-7510",
  tel: "tel:+14143967510",
  sms: "sms:+14143967510",
  region: "Southeastern Wisconsin",
  address: "9000 W Chester St, Ste 100, Milwaukee, WI 53214",
  hours: ["Mon–Fri 9:30 AM – 7:30 PM", "Sat 12:30 PM – 5:00 PM"],
  license: "WI Lic. 1452-DCFR",
  founded: "2024",
  experience: "7+",
  bbbSince: "Nov 2024",
  facebook: "https://www.facebook.com/61575186324611/",
  youtube: "https://www.youtube.com/@GoodhomeimprovementLLC",
  bbb: "https://www.bbb.org/us/wi/milwaukee/profile/roofing-contractors/good-home-improvement-llc-0694-1000061352",
  angi: "https://www.angi.com/companylist/us/wi/milwaukee/good-home-improvement-llc-reviews-145672032.htm",
  google: "https://search.google.com/local/reviews?placeid=ChIJUyMPbrEqaysRX0JIQmMclU8",
  googleReview: "https://search.google.com/local/writereview?placeid=ChIJUyMPbrEqaysRX0JIQmMclU8",
  gaf: "https://www.gaf.com/en-us/roofing-contractors/residential/usa/wi/milwaukee/good-home-improvement-llc-1148345",
  gafId: "1148345",
};

export const TRUST = [
  { big: "A", small: "BBB Rating", sub: "Accredited since 2024" },
  { big: "5.0★", small: "Google Reviews", sub: "Five-star rated" },
  { big: "7+", small: "Years experience", sub: "Roofs, siding & gutters" },
  { big: "FREE", small: "Drone inspection", sub: "See your roof up close" },
  { big: "GAF", small: "Certified™ contractor", sub: `GAF ID 1148345` },
];

export const REVIEWS = [
  { name: "Elsa M.", src: "Angi", tag: "Hail damage roof", text: "Our roof suffered serious damage from a recent hailstorm, and Good Home Improvement handled the entire process seamlessly from start to finish. They helped guide us through every step and were able to get our full replacement approved for a brand-new roof. Professional, efficient, and reliable we highly recommend them!" },
  { name: "Tom F.", src: "Angi", tag: "Gutter covers", text: "Highly recommend!! Super easy to communicate with and we were able to schedule our work promptly. They arrived on time and worked safely. They cleaned out our gutters and installed covers. Took before and after photos since we were not able to get up there. Overall exactly what we needed and they made it a breeze!" },
  { name: "John B.", src: "Angi", tag: "Roof, siding & gutters", text: "I highly recommend the business to work on your roof, siding, and gutters." },
  { name: "Safi B.", src: "Angi", tag: "Roof & gutters", text: "Love our new roof and gutters — highly recommend them for your roof replacement." },
  { name: "Clementine U.", src: "Angi", tag: "New roof", text: "The roof looks great. Will recommend them to friends and family." },
  { name: "Pier E.", src: "BBB", tag: "New roof", text: "I love the color. The work was excellent." },
];

export const VIDEOS = [
  { id: "RYGHD-3xH2M", title: "Complete roof replacements in Milwaukee" },
  { id: "yv2NiCgH1wE", title: "Complete roof, siding & gutter replacement" },
  { id: "Sy-xCUeKgYA", title: "Free drone roof inspection" },
  { id: "f1OQvldWcfk", title: "Before & after — 2025 projects" },
  { id: "tI-xSdNMcwA", title: "Another brand new roof" },
  { id: "Z5aZKuJoJbE", title: "Garage makeover: new siding & roof" },
];

export const IMG = {
  hero: "/img/fb/job-site.jpg",
  colonial: "/img/fb/roof-inspection.jpg",
  farmhouse: "/img/fb/happy-customers.jpg",
  storm: "/img/fb/roof-in-progress.jpg",
  metal: "/img/fb/material-delivery.jpg",
  shingle: "/img/fb/timberline-shingles.jpg",
  siding: "/img/yt/c_F0QWD0PJZ-8.jpg",
  gutters: "/img/yt/c_pSq34Qf4Faw.jpg",
  crewHero: "/img/fb/crew-on-roof.jpg",
  crewSiding: "/img/fb/finished-home.jpg",
  crewGutters: "/img/yt/c_rY7ygqCw3mw.jpg",
  crewTeam: "/img/fb/crew-lineup.jpg",
  crewDetail: "/img/yt/c_BNebnhpLGc0.jpg",
  van: "/img/fb/work-van.jpg",
  realHome: "/img/real/finished_home.jpg",
  before: "/img/real/roof1_before.jpg",
  after: "/img/fb/finished-home.jpg",
};

export const NAV = [
  { to: "/roofing", label: "Roofing" },
  { to: "/siding", label: "Siding" },
  { to: "/gutters", label: "Gutters" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

// Towns served (each has its own page, see data/areas.js)
export const AREAS = ["Menomonee Falls", "Brown Deer", "Oak Creek", "Wauwatosa", "Brookfield", "Waukesha", "New Berlin", "West Allis", "Milwaukee", "Mequon", "Germantown", "Greenfield", "Franklin", "Muskego"];

export const ROOF_OPTIONS = [
  { key: "asphalt", label: "Asphalt Shingles", life: "25–30 yrs", img: IMG.shingle,
    text: "The most popular roof in Wisconsin. Architectural shingles give you a dimensional look, dozens of colors and the best value per square foot.",
    points: ["Best value", "Many colors", "Fast install"] },
  { key: "cedar", label: "Cedar Wood", life: "25–35 yrs", img: IMG.colonial,
    text: "Natural cedar shakes bring warmth and character to classic and lake homes, weathering to a soft silver gray over time.",
    points: ["Natural look", "Great insulation", "Classic curb appeal"] },
  { key: "slate", label: "Slate Roofing", life: "75+ yrs", img: IMG.storm,
    text: "Real stone that can outlast the house itself. A premium choice for historic and high-end homes that want a once-in-a-lifetime roof.",
    points: ["Longest lifespan", "Fireproof", "Premium look"] },
  { key: "metal", label: "Metal Roofing", life: "40–70 yrs", img: IMG.metal,
    text: "Standing seam metal sheds heavy snow, stands up to wind and hail, and keeps a clean modern profile for decades.",
    points: ["Sheds snow", "Wind & hail tough", "Low maintenance"] },
];

export const SERVICES = [
  {
    slug: "roofing", title: "Roofing", kicker: "Roof replacement & repair", img: IMG.crewHero, detail: IMG.shingle, why: IMG.crewDetail,
    blurb: "Full tear-offs, new roofs and storm damage repairs built for Wisconsin winters.",
    intro: "Your roof takes the worst of Midwest weather: heavy snow, ice dams, hail and spring storms. We walk you through every option, show you what is going on up there and install your new roof the right way the first time.",
    offerings: ["Complete roof replacement", "GAF Timberline HDZ shingles", "Hail & storm damage — insurance claim guidance", "Roof leak repair", "Residential & commercial roofing", "Free drone roof inspection"],
    faqs: [
      { q: "How do I know if I need a new roof?", a: "Curling or missing shingles, granules in the gutters, leaks, or a roof over 20 years old are common signs. We will inspect it and give you an honest answer." },
      { q: "Do you help with storm damage?", a: "Yes. After hail or wind we inspect the roof, document the damage with photos and guide you through the insurance process — homeowners have had full replacements approved with our help." },
      { q: "How long does a roof replacement take?", a: "Most homes are finished in one to two days, depending on size, weather and the material you choose." },
    ],
  },
  {
    slug: "siding", title: "Siding", kicker: "New siding & repairs", img: IMG.crewSiding, detail: IMG.siding, why: IMG.realHome,
    blurb: "Vinyl, engineered wood and board & batten siding that transforms curb appeal.",
    intro: "New siding protects your home from moisture, wind and cold while giving it a whole new look. We help you choose the style and color, then install it with clean, tight trim work.",
    offerings: ["Vinyl siding install & replacement", "Engineered wood siding", "Board & batten", "Soffit & fascia", "Exterior trim wrap", "Siding repair"],
    faqs: [
      { q: "What siding is best for Wisconsin?", a: "Vinyl and engineered wood both handle freeze-thaw cycles well. We will show you samples and explain the pros and cons of each." },
      { q: "Can you match my existing siding for a repair?", a: "In many cases, yes. We will look at the profile and color and find the closest match available." },
      { q: "Do you replace soffit and fascia too?", a: "Yes, we can replace soffit, fascia and trim at the same time for a finished look." },
    ],
  },
  {
    slug: "gutters", title: "Gutters", kicker: "Seamless gutters & guards", img: IMG.hero, detail: IMG.gutters, why: IMG.crewGutters,
    blurb: "Seamless gutters, downspouts and guards that keep water away from your foundation.",
    intro: "Gutters protect your roof, siding and foundation from water damage. We install seamless gutters sized for your roof, with downspouts placed where they actually do their job.",
    offerings: ["Seamless metal gutters", "Downspouts & extensions", "Gutter covers & guards", "Gutter clean-out with before/after photos", "Fascia repair", "Color matched to your home"],
    faqs: [
      { q: "Why seamless gutters?", a: "Fewer seams means fewer places to leak. Seamless gutters are formed on site to the exact length of your home." },
      { q: "Do gutter guards really work?", a: "Good guards keep leaves and debris out so water can flow freely, which means far less cleaning for you." },
      { q: "Can I replace gutters with my roof?", a: "Yes, and it is a great time to do it. We can handle roof and gutters in one project." },
    ],
  },
];

// Storm damage landing pages (not a nav service; lives at /storm-damage and /storm-damage/<town>)
export const STORM = {
  slug: "storm-damage", title: "Storm Damage", h1: "Storm & hail damage repair", formService: "Roofing",
  kicker: "Hail & storm damage roof repair", img: IMG.storm, detail: IMG.before, why: IMG.crewDetail,
  blurb: "Hail, wind and storm damage inspections, insurance claim help and full roof repairs or replacements.",
  intro: "After a hailstorm or high winds, damage is not always easy to see from the ground: bruised or cracked shingles, lifted tabs, dented vents and gutters, and torn siding. We inspect your roof up close, including drone photos, document every bit of damage and walk you through your insurance claim from start to finish.",
  offerings: ["Free hail & wind damage inspection", "Drone photos of your roof", "Damage documented for your insurance claim", "Insurance claim guidance, step by step", "Storm damage roof repair & replacement", "Damaged siding & gutter repair"],
  faqs: [
    { q: "How do I know if hail damaged my roof?", a: "Look for dents on gutters, vents and downspouts, granules washing out of the downspouts, or cracked and missing shingles. The surest way is a free inspection. We check the roof up close and show you the photos." },
    { q: "Will insurance pay for a new roof after hail?", a: "It depends on your policy and the damage. We document the damage with photos and guide you through the claim. Homeowners have had full roof replacements approved with our help." },
    { q: "What should I do right after a storm?", a: "Take photos of any visible damage, watch ceilings for leaks, and call us at 414-396-7510 for a free inspection before you file or while your claim is open." },
  ],
};

export const STEPS = [
  { n: "01", t: "Call or request", d: "Call 414-396-7510 or send the form. We will set up a time that works for you." },
  { n: "02", t: "Free drone inspection", d: "We inspect your roof, siding or gutters — including drone photos — and show you exactly what we find." },
  { n: "03", t: "Clear estimate", d: "You get your options explained in plain language, with no pressure." },
  { n: "04", t: "Done right", d: "We install, clean up the job site and walk through the finished work with you." },
];
